import { withInstall } from '@bigin/utils'
import Tooltip from './src/tooltip.vue'

export const BTooltip = withInstall(Tooltip)
export * from './src/tooltip'
export * from './src/trigger'
export * from './src/content'
export default BTooltip
